/* ══ PREASENS — LIFTFACE JS ══ */
var LF_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var LF_LANG = document.documentElement.lang || 'fr';
function lf_t(key, fallback){
  return (window.LF_T && window.LF_T[key]) || fallback;
}
function lf_money(cents){
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  try {
    return new Intl.NumberFormat(LF_LANG, { style: 'currency', currency: cur }).format((cents || 0) / 100);
  } catch(e) {
    return ((cents || 0) / 100).toFixed(2) + ' ' + cur;
  }
}

/* ── Offre de bienvenue — helpers partagés ── */
function lfWelcomeDeadline(){
  try{ var d = parseInt(localStorage.getItem('lfwp_deadline')||'0',10); return d > Date.now() ? d : 0; }catch(e){ return 0; }
}
function lfWelcomeActive(){
  try{ return localStorage.getItem('lfwp_seen') === '1' && lfWelcomeDeadline() > 0; }catch(e){ return false; }
}
var LF_WELCOME_LABEL = (LF_LANG.indexOf('en') === 0) ? 'welcome offer' : 'offre de bienvenue';

/* Announcement bar */
(function(){
  var msgs = document.querySelectorAll('.announcement-msg');
  if(msgs.length === 0) return;
  var current = 0;
  msgs[0].classList.add('active');
  if(msgs.length > 1){
    setInterval(function(){
      msgs[current].classList.remove('active');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('active');
    }, 3000);
  }
})();

/* Mobile hero swipe */
(function(){
  var track = document.getElementById('hero-swipe-track');
  var dotsWrap = document.getElementById('hero-dots');
  if(!track || !dotsWrap) return;
  var slides = track.querySelectorAll('.hero-slide');
  if(slides.length === 0) return;
  slides.forEach(function(_, i){
    var dot = document.createElement('button');
    dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', lf_t('photo', 'Photo') + ' ' + (i + 1));
    dot.addEventListener('click', function(){
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    });
    dotsWrap.appendChild(dot);
  });
  var dots = dotsWrap.querySelectorAll('.hero-dot');
  var mobileThumbs = document.querySelectorAll('.hero-mobile-thumb');
  mobileThumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var slideIdx = parseInt(this.getAttribute('data-slide'));
      if(slides[slideIdx]){
        track.scrollTo({ left: slides[slideIdx].offsetLeft, behavior: 'smooth' });
      }
    });
  });
  var scrollTimer;
  track.addEventListener('scroll', function(){
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function(){
      var scrollLeft = track.scrollLeft;
      var trackW = track.offsetWidth;
      var idx = Math.round(scrollLeft / trackW);
      dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
      mobileThumbs.forEach(function(t, i){ t.classList.toggle('active', i === idx); });
    }, 50);
  });
})();

/* Sticky bar */
(function(){
  var sbar = document.getElementById('sticky-bar');
  var hero = document.getElementById('hero');
  if(sbar && hero){
    new IntersectionObserver(function(e){sbar.classList.toggle('show',!e[0].isIntersecting);},{threshold:.1}).observe(hero);
  }
})();

/* Mobile menu */
(function(){
  var hamburger = document.getElementById('nav-hamburger');
  var menu = document.getElementById('mobile-menu');
  var overlay = document.getElementById('mobile-menu-overlay');
  var closeBtn = document.getElementById('mobile-menu-close');
  if(!hamburger || !menu) return;
  function openMenu(){ menu.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeMenu(){ menu.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; }
  hamburger.addEventListener('click', openMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  if(overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeMenu(); });
  menu.querySelectorAll('.mobile-menu-links a').forEach(function(a){ a.addEventListener('click', closeMenu); });
})();

/* Hero trust rotating */
(function(){
  var msgs = document.querySelectorAll('.hero-trust-msg');
  var dots = document.querySelectorAll('.htd');
  if(msgs.length === 0) return;
  var idx = 0;
  setInterval(function(){
    msgs[idx].classList.remove('active');
    if(dots[idx]) dots[idx].classList.remove('active');
    idx = (idx + 1) % msgs.length;
    msgs[idx].classList.add('active');
    if(dots[idx]) dots[idx].classList.add('active');
  }, 2000);
})();

/* Reveal */
document.querySelectorAll('.rv,.rv-left,.rv-right,.rv-scale,.rv-type').forEach(function(el){
  new IntersectionObserver(function(e){if(e[0].isIntersecting){e[0].target.classList.add('v');e[0].target.dispatchEvent(new Event('revealed'));}},{threshold:.1}).observe(el);
});

/* Counter animation */
(function(){
  document.querySelectorAll('.count-up').forEach(function(el){
    var counted = false;
    new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting && !counted){
        counted = true;
        var raw = el.getAttribute('data-count') || '0';
        var target = parseFloat(raw.replace(/[^0-9.]/g,''));
        var suffix = el.textContent.replace(/[0-9.,]/g,'').trim() || raw.replace(/[0-9.]/g,'');
        var isDecimal = raw.indexOf('.') !== -1;
        var duration = 1800;
        var start = performance.now();
        function step(now){
          var progress = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(ease * target);
          if(isDecimal) current = (ease * target).toFixed(1);
          el.textContent = current.toLocaleString(LF_LANG) + suffix;
          if(progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
    },{threshold:.2}).observe(el);
  });
})();

/* Gallery thumbs */
(function(){
  var mainImg = document.getElementById('hero-main-photo');
  if(!mainImg) return;
  document.querySelectorAll('.hero-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.hero-thumb').forEach(function(x){x.classList.remove('active');});
      this.classList.add('active');
      var full = this.getAttribute('data-full');
      if(full && mainImg.tagName === 'IMG') mainImg.src = full;
    });
  });
})();

/* Toggle reviews */
(function(){
  var btn = document.getElementById('rev-toggle');
  var extra = document.getElementById('reviews-extra');
  if(!btn || !extra) return;
  var open = false;
  btn.addEventListener('click',function(){
    open = !open;
    extra.classList.toggle('show', open);
    btn.textContent = open ? lf_t('show_less', 'Voir moins') : lf_t('show_more', 'Afficher plus');
    if(open){
      extra.querySelectorAll('.rv').forEach(function(el){
        new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
      });
    }
  });
})();

/* Tabs: Avis / Questions */
(function(){
  var tabs = document.querySelectorAll('.reviews-tab');
  if(tabs.length < 2) return;
  var reviewsList = document.getElementById('reviews-list');
  var reviewsExtra = document.getElementById('reviews-extra');
  var reviewsMore = document.querySelector('.reviews-more');
  var reviewsActions = document.querySelector('.reviews-actions');
  var questionsPanel = document.getElementById('questions-panel');
  tabs.forEach(function(tab, idx){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){ t.classList.remove('active'); });
      this.classList.add('active');
      if(idx === 0){
        if(reviewsList) reviewsList.style.display = '';
        if(reviewsExtra) reviewsExtra.style.display = '';
        if(reviewsMore) reviewsMore.style.display = '';
        if(reviewsActions) reviewsActions.style.display = '';
        if(questionsPanel) questionsPanel.style.display = 'none';
      } else {
        if(reviewsList) reviewsList.style.display = 'none';
        if(reviewsExtra) reviewsExtra.style.display = 'none';
        if(reviewsMore) reviewsMore.style.display = 'none';
        if(reviewsActions) reviewsActions.style.display = 'none';
        if(questionsPanel){ questionsPanel.style.display = 'block';
          questionsPanel.querySelectorAll('.rv').forEach(function(el){
            new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
          });
        }
      }
    });
  });
})();

/* FAQ accordions */
document.querySelectorAll('.faq-q,.pq-q').forEach(function(q){
  q.addEventListener('click',function(){
    var item = this.parentElement;
    var siblings = item.parentElement.querySelectorAll('.faq-item,.pq-item');
    var wasOpen = item.classList.contains('open');
    siblings.forEach(function(x){x.classList.remove('open');});
    if(!wasOpen) item.classList.add('open');
  });
});

/* ══ CART DRAWER ══ */
(function(){
  /* Le tiroir CL (snippet cl-cart-drawer) est present sur toutes les pages : l'ancien tiroir est inutile. */
  if(document.getElementById('cld')) return;

  var drawer = document.createElement('div');
  drawer.id = 'cart-drawer';
  drawer.innerHTML = '<div class="cart-drawer-overlay"></div><div class="cart-drawer-panel">' +
    '<div class="cart-drawer-head">' +
      '<span class="cart-drawer-title">' + lf_t('cart_title', 'Panier') + ' <span class="cart-drawer-count" id="cart-drawer-count"></span></span>' +
      '<button class="cart-drawer-close"><svg viewBox="0 0 24 24" style="width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:2;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
    '</div>' +
    '<div class="cart-drawer-timer" id="cart-drawer-timer" style="display:none;"></div>' +
    '<div class="cart-drawer-secure" id="cart-drawer-secure" style="display:none;">' +
      '<strong>' + lf_t('secure_title', 'Paiements sécurisés') + '</strong>' +
      '<span>' + lf_t('secure_desc_html', 'Par carte bancaire, PayPal ou <span class="klarna-inline-badge"><span class="klarna-wordmark">Klarna<span class="klarna-dot">.</span></span></span>') + '</span>' +
    '</div>' +
    '<div class="cart-drawer-body" id="cart-drawer-body">' +
      '<div class="cart-empty">' +
        '<p class="cart-empty-text">' + lf_t('cart_empty_html', 'VOTRE PANIER<br>EST VIDE') + '</p>' +
      '</div>' +
    '</div>' +
    '<div class="cart-drawer-reco" id="cart-drawer-reco"></div>' +
    '<div class="cart-drawer-foot" id="cart-drawer-foot"></div>' +
  '</div>';
  document.body.appendChild(drawer);

  var overlay = drawer.querySelector('.cart-drawer-overlay');
  var closeBtn = drawer.querySelector('.cart-drawer-close');

  function openDrawer(){ drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ drawer.classList.remove('open'); document.body.style.overflow=''; }
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  var cartIcon = document.querySelector('.nav-cart-icon');
  if(cartIcon){
    cartIcon.style.cursor = 'pointer';
    cartIcon.addEventListener('click', function(){ refreshCart(); openDrawer(); });
  }

  /* Countdown — synchronisé avec lfwp_deadline */
  var timerInterval = null;
  var timerSeconds = 30 * 60;
  function timerHTML(){
    var m = Math.floor(timerSeconds / 60);
    var s = timerSeconds % 60;
    var time = m + ':' + (s < 10 ? '0' : '') + s;
    var tpl = lf_t('reserved_html', 'Votre panier est réservé pendant <strong>{time}</strong>');
    return '<span>' + tpl.replace('{time}', time) + '</span>';
  }
  function startTimer(){
    var timerEl = document.getElementById('cart-drawer-timer');
    if(!timerEl) return;
    timerEl.style.display = 'flex';
    if(timerInterval) clearInterval(timerInterval);
    function tick(){
      var dl = lfWelcomeDeadline();
      if(dl){
        timerSeconds = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      } else {
        timerSeconds--;
        if(timerSeconds <= 0){ clearInterval(timerInterval); timerSeconds = 0; }
      }
      timerEl.innerHTML = timerHTML();
    }
    var dl0 = lfWelcomeDeadline();
    timerSeconds = dl0 ? Math.max(0, Math.floor((dl0 - Date.now()) / 1000)) : 30 * 60;
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* Recommended */
  function buildRecoHTML(cart){
    var recoEl = document.getElementById('cart-drawer-reco');
    if(!recoEl) return;
    var allProducts = [
      { handle: 'liftface-pro', title: 'LiftFace Pro', subtitle: lf_t('reco_pro_sub', 'EMS + LED + Microvibrations') },
      { handle: 'liftface-lite', title: 'LiftFace Lite', subtitle: lf_t('reco_lite_sub', 'Vibrations + Chaleur') }
    ];
    var cartHandles = (cart && cart.items) ? cart.items.map(function(i){ return i.handle; }) : [];
    var filtered = allProducts.filter(function(p){ return cartHandles.indexOf(p.handle) === -1; });
    if(filtered.length === 0){ recoEl.innerHTML = ''; return; }

    var html = '<div class="reco-header"><strong>' + lf_t('recommended', 'Recommandé') + '</strong></div><div class="reco-cards">';
    filtered.forEach(function(p){
      html += '<div class="reco-card">' +
        '<div class="reco-card-inner">' +
          '<div class="reco-card-info">' +
            '<div class="reco-card-title">' + p.title + '</div>' +
            '<div class="reco-card-sub">' + p.subtitle + '</div>' +
            '<div class="reco-card-price" data-reco-price="' + p.handle + '"></div>' +
          '</div>' +
          '<button class="reco-add-btn" data-handle="' + p.handle + '">' + lf_t('add', 'AJOUTER') + '</button>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    recoEl.innerHTML = html;

    filtered.forEach(function(p){
      fetch(LF_ROOT + 'products/' + p.handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(prod){
          var el = recoEl.querySelector('[data-reco-price="' + p.handle + '"]');
          if(el && prod && prod.variants && prod.variants.length){ el.textContent = lf_money(prod.variants[0].price); }
        }).catch(function(){});
    });

    recoEl.querySelectorAll('.reco-add-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var handle = this.getAttribute('data-handle');
        var self = this;
        self.textContent = '...';
        self.disabled = true;
        fetch(LF_ROOT + 'products/' + handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(product){
          return fetch(LF_ROOT + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: product.variants[0].id, quantity: 1})
          });
        })
        .then(function(){ refreshCart(); updateBadge(); })
        .catch(function(){ self.textContent = lf_t('add', 'AJOUTER'); self.disabled = false; });
      });
    });
  }

  /* ── Refresh cart drawer — tous les montants dérivent des MÊMES chiffres par article ── */
  function refreshCart(){
    fetch(LF_ROOT + 'cart.js').then(function(r){return r.json();}).then(function(cart){
      var body = document.getElementById('cart-drawer-body');
      var foot = document.getElementById('cart-drawer-foot');
      var countEl = document.getElementById('cart-drawer-count');
      var timerEl = document.getElementById('cart-drawer-timer');
      var secureEl = document.getElementById('cart-drawer-secure');
      var promo = lfWelcomeActive();

      if(countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

      if(cart.item_count === 0){
        body.innerHTML = '<div class="cart-empty"><p class="cart-empty-text">' + lf_t('cart_empty_html', 'VOTRE PANIER<br>EST VIDE') + '</p></div>';
        foot.innerHTML = '';
        if(timerEl) timerEl.style.display = 'none';
        if(secureEl) secureEl.style.display = 'none';
        if(timerInterval){ clearInterval(timerInterval); timerInterval = null; }
        buildRecoHTML(cart);
        return;
      }

      if(secureEl) secureEl.style.display = 'flex';
      if(!timerInterval) startTimer();

      var sumOld = 0, sumNew = 0;
      var html = '';
      cart.items.forEach(function(item, i){
        var img = item.image ? '<img src="'+item.image.replace(/(\.[^.]+)$/,'_200x$1')+'" alt="'+item.title+'">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">'+item.variant_title+'</div>' : '';
        var origL = item.original_line_price || item.final_line_price;
        var finalL = item.final_line_price;
        var oldL = Math.max(origL, finalL);
        var newL = origL > finalL ? finalL : Math.round(finalL * 0.9);
        var priceHtml;
        if(promo){
          sumOld += oldL; sumNew += newL;
          priceHtml = '<div class="cart-item-price">' +
            '<s style="color:#d92b2b;font-weight:500;margin-right:7px;">'+lf_money(oldL)+'</s>' +
            '<strong>'+lf_money(newL)+'</strong>' +
            '<span style="display:inline-block;margin-left:8px;font-size:10.5px;font-weight:700;color:#0a7a52;background:#e6f5ee;padding:2px 8px;border-radius:999px;white-space:nowrap;">−10% ('+LF_WELCOME_LABEL+')</span>' +
          '</div>';
        } else {
          sumOld += finalL; sumNew += finalL;
          priceHtml = '<div class="cart-item-price">'+lf_money(finalL)+'</div>';
        }
        html += '<div class="cart-item" style="animation-delay:'+( i * 0.06 )+'s">' +
          '<div class="cart-item-img">'+img+'</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">'+item.title+'</div>'+variant+
            priceHtml +
            '<div class="cart-item-qty">' +
              '<div class="cart-qty-select">' +
                '<span>'+item.quantity+'</span>' +
                '<svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;fill:none;stroke-width:2;"><polyline points="6 9 12 15 18 9"/></svg>' +
                '<select class="cart-qty-dropdown" data-key="'+item.key+'">';
        for(var q=1;q<=10;q++){
          html += '<option value="'+q+'"'+(q===item.quantity?' selected':'')+'>'+q+'</option>';
        }
        html += '</select></div></div></div>' +
          '<button class="cart-item-remove cart-qty-btn" data-key="'+item.key+'" data-qty="0">' +
            '<svg viewBox="0 0 24 24"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>' +
          '</button>' +
        '</div>';
      });
      body.innerHTML = html;

      var shippingHtml = '<div class="cart-shipping-bar"><div class="cart-shipping-fill" style="width:100%"></div><span class="cart-shipping-text"><svg viewBox="0 0 24 24" style="width:14px;height:14px;stroke:currentColor;fill:none;stroke-width:2;"><polyline points="20 6 9 17 4 12"/></svg> ' + lf_t('free_shipping_html', '<strong>Livraison gratuite</strong> incluse') + '</span></div>';

      var trustHtml = '<div class="cart-trust-row">' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' + lf_t('guarantee', 'Garantie 30j') + '</div>' +
        '<div class="cart-trust-item cart-trust-klarna"><span class="klarna-wordmark">Klarna<span class="klarna-dot">.</span></span> 3x</div>' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>' + lf_t('secure', 'Sécurisé') + '</div>' +
        '<div class="cart-trust-item"><svg viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>' + lf_t('delivery', '6j ouvrés') + '</div>' +
      '</div>';

      var totalRows = '<div class="cart-total"><span>' + lf_t('shipping_label', 'Frais de livraison') + '</span><strong>' + lf_t('free', 'Gratuit') + '</strong></div>';
      var checkoutBtn;
      if(promo && sumOld > sumNew){
        totalRows += '<div class="cart-total"><span>WELCOME10 — −10% (' + LF_WELCOME_LABEL + ')</span><strong style="color:#0a7a52;">−' + lf_money(sumOld - sumNew) + '</strong></div>';
        checkoutBtn = '<a href="' + LF_ROOT + 'checkout" class="cart-checkout-btn">' + lf_t('checkout', 'PAIEMENT') + ' &mdash; <s style="opacity:.8;font-weight:500;margin:0 7px 0 4px;color:#ff9d9d;">' + lf_money(sumOld) + '</s> ' + lf_money(sumNew) + '</a>';
      } else {
        checkoutBtn = '<a href="' + LF_ROOT + 'checkout" class="cart-checkout-btn">' + lf_t('checkout', 'PAIEMENT') + ' &mdash; ' + lf_money(sumNew) + '</a>';
      }

      foot.innerHTML = shippingHtml + trustHtml + totalRows + checkoutBtn;

      body.querySelectorAll('.cart-qty-dropdown').forEach(function(sel){
        sel.addEventListener('change', function(){
          var key = this.getAttribute('data-key');
          var qty = parseInt(this.value);
          fetch(LF_ROOT + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){refreshCart();updateBadge();});
        });
      });

      body.querySelectorAll('.cart-qty-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var key = this.getAttribute('data-key');
          fetch(LF_ROOT + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})}).then(function(){refreshCart();updateBadge();});
        });
      });

      buildRecoHTML(cart);
    });
  }

  window.lfRefreshCartPromo = refreshCart;

  /* Badge */
  function updateBadge(){
    fetch(LF_ROOT + 'cart.js').then(function(r){return r.json();}).then(function(cart){
      var badge = document.getElementById('cart-badge');
      if(!badge){
        badge = document.createElement('span');
        badge.id = 'cart-badge';
        badge.className = 'cart-badge';
        var badgeParent = document.querySelector('.nav-cart-icon');
        if(badgeParent) badgeParent.appendChild(badge);
      }
      if(cart.item_count > 0){ badge.textContent = cart.item_count; badge.style.display = 'flex'; }
      else { badge.style.display = 'none'; }
    });
  }
  updateBadge();

  function getProductHandle(){
    var heroEl = document.getElementById('hero');
    return heroEl ? (heroEl.getAttribute('data-product-handle') || '') : '';
  }

  var heroForm = document.getElementById('hero-add-form');

  if(heroForm){
    heroForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn = heroForm.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if(btn){ btn.textContent = lf_t('adding', 'Ajout en cours...'); btn.style.opacity = '.6'; btn.disabled = true; }
      var data = new FormData(heroForm);
      fetch(LF_ROOT + 'cart/add.js',{method:'POST',body:data})
      .then(function(r){return r.json();})
      .then(function(){
        if(btn){ btn.textContent = lf_t('added', '✓ Ajouté !'); btn.style.opacity = '1'; }
        refreshCart();
        updateBadge();
        openDrawer();
        setTimeout(function(){ if(btn){ btn.textContent = originalText; btn.disabled = false; } }, 2000);
      })
      .catch(function(){
        if(btn){ btn.textContent = originalText; btn.style.opacity = '1'; btn.disabled = false; }
      });
    });
  }

  document.querySelectorAll('.add-to-cart-btn').forEach(function(btn){
    if(btn.closest('form')) return;
    btn.addEventListener('click',function(e){
      e.preventDefault();
      if(heroForm){
        heroForm.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
      } else {
        var handle = getProductHandle();
        if(!handle) return;
        var originalText = this.textContent;
        this.textContent = lf_t('adding', 'Ajout en cours...'); this.style.opacity = '.6'; this.disabled = true;
        var self = this;
        fetch(LF_ROOT + 'products/' + handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(product){
          return fetch(LF_ROOT + 'cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({id:product.variants[0].id, quantity:1})
          });
        })
        .then(function(){
          self.textContent = lf_t('added', '✓ Ajouté !'); self.style.opacity = '1';
          refreshCart(); updateBadge(); openDrawer();
          setTimeout(function(){ self.textContent = originalText; self.disabled = false; }, 2000);
        })
        .catch(function(){ self.textContent = originalText; self.style.opacity = '1'; self.disabled = false; });
      }
    });
  });

  function buyNowWithHandle(handle, btn){
    if(!handle) return;
    var originalText = btn ? btn.textContent : '';
    if(btn){ btn.textContent = lf_t('redirecting', 'Redirection...'); btn.style.opacity = '.6'; btn.disabled = true; }
    fetch(LF_ROOT + 'products/' + handle + '.js')
    .then(function(r){ return r.json(); })
    .then(function(product){
      var variantId = product.variants[0].id;
      return fetch(LF_ROOT + 'cart/clear.js',{method:'POST'})
      .then(function(){
        return fetch(LF_ROOT + 'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:variantId, quantity:1})
        });
      });
    })
    .then(function(){ window.location.href = LF_ROOT + 'checkout'; })
    .catch(function(){
      if(btn){ btn.textContent = originalText; btn.style.opacity = '1'; btn.disabled = false; }
    });
  }

  document.querySelectorAll('.buy-now-btn').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      var handle = getProductHandle();
      if(handle){
        buyNowWithHandle(handle, this);
      } else if(heroForm){
        var self = this;
        var originalText = self.textContent;
        self.textContent = lf_t('redirecting', 'Redirection...'); self.style.opacity = '.6'; self.disabled = true;
        var data = new FormData(heroForm);
        fetch(LF_ROOT + 'cart/clear.js',{method:'POST'})
        .then(function(){ return fetch(LF_ROOT + 'cart/add.js',{method:'POST',body:data}); })
        .then(function(){ window.location.href = LF_ROOT + 'checkout'; })
        .catch(function(){ self.textContent = originalText; self.style.opacity = '1'; self.disabled = false; });
      }
    });
  });

  document.querySelectorAll('.buy-now-link[data-buy-handle]').forEach(function(link){
    link.addEventListener('click',function(e){
      e.preventDefault();
      var handle = this.getAttribute('data-buy-handle');
      if(handle) buyNowWithHandle(handle, this);
    });
  });

  document.querySelectorAll('.klarna-buy-btn').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var self = this;
      var originalText = self.innerHTML;
      self.textContent = lf_t('redirecting', 'Redirection...');
      self.style.opacity = '.6';
      self.disabled = true;
      var handle = getProductHandle();
      if(handle){
        fetch(LF_ROOT + 'products/' + handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(product){
          var variantId = product.variants[0].id;
          return fetch(LF_ROOT + 'cart/clear.js',{method:'POST'})
          .then(function(){
            return fetch(LF_ROOT + 'cart/add.js',{
              method:'POST',
              headers:{'Content-Type':'application/json'},
              body:JSON.stringify({id:variantId, quantity:1})
            });
          });
        })
        .then(function(){
          window.location.href = LF_ROOT + 'checkout?step=payment_method';
        })
        .catch(function(){
          self.innerHTML = originalText;
          self.style.opacity = '1';
          self.disabled = false;
        });
      } else if(heroForm){
        var data = new FormData(heroForm);
        fetch(LF_ROOT + 'cart/clear.js',{method:'POST'})
        .then(function(){ return fetch(LF_ROOT + 'cart/add.js',{method:'POST',body:data}); })
        .then(function(){ window.location.href = LF_ROOT + 'checkout?step=payment_method'; })
        .catch(function(){
          self.innerHTML = originalText;
          self.style.opacity = '1';
          self.disabled = false;
        });
      }
    });
  });

})();

/* Review photo lightbox */
(function(){
  if(!document.querySelector('[onclick*="openReviewPhoto"]')) return;
  var lb = document.createElement('div');
  lb.className = 'review-lightbox';
  lb.innerHTML = '<button class="review-lightbox-close">&times;</button><img src="" alt="">';
  document.body.appendChild(lb);
  var img = lb.querySelector('img');
  var closeBtn = lb.querySelector('.review-lightbox-close');
  window.openReviewPhoto = function(el){
    var src = el.querySelector('img').src;
    img.src = src;
    lb.classList.add('open');
  };
  closeBtn.addEventListener('click', function(){ lb.classList.remove('open'); });
  lb.addEventListener('click', function(e){ if(e.target === lb) lb.classList.remove('open'); });
})();

/* MutationObserver */
(function(){
  var sel = '.rv:not(.v),.rv-left:not(.v),.rv-right:not(.v),.rv-scale:not(.v),.rv-type:not(.v)';
  if(typeof MutationObserver !== 'undefined'){
    new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if(n.nodeType === 1){
            if(n.matches && n.matches(sel)){
              new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(n);
            }
            n.querySelectorAll && n.querySelectorAll(sel).forEach(function(el){
              new IntersectionObserver(function(e){if(e[0].isIntersecting)e[0].target.classList.add('v');},{threshold:.1}).observe(el);
            });
          }
        });
      });
    }).observe(document.body, {childList:true, subtree:true});
  }
})();
